module.exports = __webpack_public_path__ + "img/selected2-min.aa1e8635.png";